<template>
  <div class="page-wrap">
    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header-left">
          <div class="panel-icon"><i class="fa fa-building"></i></div>
          <div>
            <div class="panel-title">
              Company-wise Service Report
              <span class="count-badge" v-if="!load && !getLoadingData && reports.length > 0">
                {{ reports.length }} records
              </span>
            </div>
            <div class="panel-sub">Fingerprint service records grouped by company</div>
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="filter-bar">
        <adv-search @search="advSearch" :is_company="true" :is_date_range="true" :is_service="true" :is_status="true"
          :is_payment_status="true" :reportData="excelreports" :titleworksheet="titleworksheet"
          :json_fields="json_fields" :header="header" :is_admin_sp_company="true" :report_name="'company_report.xls'" />
      </div>

      <!-- Initial prompt -->
      <div class="state-box" v-if="load">
        <i class="fa fa-filter"></i>
        Select the search criteria above and click Search
      </div>

      <!-- Loading -->
      <div class="state-box" v-else-if="getLoadingData">
        <i class="fa fa-spinner fa-spin"></i>
        Generating report…
      </div>

      <!-- Empty -->
      <div class="state-box" v-else-if="reports.length === 0">
        <i class="fa fa-inbox"></i>
        No report data found for the selected criteria
      </div>

      <!-- Table -->
      <div class="table-wrap" v-else>
        <table class="cw-table">
          <thead>
            <tr>
              <th style="width:40px;">#</th>
              <th style="min-width:60px;">App No.</th>
              <th v-if="search.company === 'all'" style="min-width:140px;">Company</th>
              <th style="min-width:150px;">Applicant / TCN</th>
              <th style="min-width:130px;">Service</th>
              <th style="min-width:120px;">Location</th>
              <th style="min-width:100px;">Svc Status</th>
              <th style="min-width:90px;">Payment</th>
              <th style="min-width:90px;">Invoice No.</th>
              <th style="min-width:100px;">Date</th>
              <th class="col-amt">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in reports" :key="index">
              <td class="col-num">{{ index + 1 }}</td>
              <td class="col-id">{{ item.id }}</td>
              <td v-if="search.company === 'all'" class="col-company">{{ item.company_name }}</td>
              <td>
                <div class="applicant-name">{{ item.applicant }}</div>
                <div class="applicant-tcn" v-if="item.tcn_number">({{ item.tcn_number }})</div>
              </td>
              <td class="col-service">{{ item.service }}</td>
              <td class="col-location">{{ item.client }}</td>
              <td>
                <span class="status-chip" :class="svcStatusClass(item.service_status)">
                  {{ item.service_status || '—' }}
                </span>
              </td>
              <td>
                <span class="status-chip" :class="payStatusClass(item.payment_status)">
                  {{ item.payment_status || '—' }}
                </span>
              </td>
              <td class="col-invoice">{{ item.company_invoice_no || '—' }}</td>
              <td class="col-date">
                <template v-if="item.enroll_date && item.enroll_date !== ''">
                  {{ dateFormat(item.enroll_date) }}
                </template>
                <template v-else-if="item.schedule_date == null">N/A</template>
                <template v-else-if="item.schedule_date !== ''">
                  {{ dateFormat(item.schedule_date) }}
                </template>
              </td>
              <td class="col-amt">
                ${{ item.amount ? parseFloat(item.amount).toFixed(2) : '0.00' }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="grand-total-row">
              <td :colspan="search.company === 'all' ? 10 : 9" class="gt-label">Grand Total</td>
              <td class="col-amt gt-value">${{ parseFloat(grand_total).toFixed(2) }}</td>
            </tr>
          </tfoot>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  FETCH_CLIENTS,
  FETCH_SERVICES,
  FETCH_COMPANY_WISE_REPORT,
  FETCH_MASTER_COMPANIES
} from "@/core/services/store/actions.type";
import {
  SET_BREADCRUMB,
  SET_COMPANY_INVOICE_APPOINTMENTS
} from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
import AdvSearch from "@/includes/search/AdvSearch";

export default {
  components: { AdvSearch },
  computed: {
    ...mapGetters(["currentUser", "getClients", "getServices", "getMasterCompanies", "getSearchDate"]),
    grand_total() {
      return this.reports.reduce((sum, el) => sum + (el.amount || 0), 0);
    }
  },
  filters: {
    toFixedTwoDigit(amount) { return parseFloat(amount).toFixed(2); }
  },
  data() {
    return {
      search: {
        service: "all",
        company: "all",
        date_from: "",
        date_to: "",
        service_status: "all",
        payment_status: "all"
      },
      titleworksheet: "",
      json_fields: {
        Company: "company_name",
        "Applicant Name": "applicant",
        Service: "service",
        Location: "client",
        "Service Status": "service_status",
        "Payment Status": "payment_status",
        "Scheduled Date": "schedule_date",
        Amount: "amount"
      },
      getLoadingData: false,
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Report", route: "" },
        { id: 3, title: "Company Wise Fingerprint Service Report", route: "" }
      ],
      reports: [],
      header: [],
      load: true,
      excelreports: []
    };
  },
  mounted() {
    this.$store.dispatch(FETCH_CLIENTS);
    this.$store.commit(SET_COMPANY_INVOICE_APPOINTMENTS, []);
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.$store.dispatch(FETCH_SERVICES, this.currentUser.u.is_client ? "self" : "all");
    this.$store.dispatch(FETCH_MASTER_COMPANIES);
  },
  methods: {
    dateFormat(date) {
      if (!date) return "";
      return moment(date).format("MM/DD/YYYY");
    },
    svcStatusClass(status) {
      if (!status || status === '—') return 'chip-neutral';
      const s = status.toLowerCase();
      if (s === 'completed' || s === 'c') return 'chip-green';
      if (s === 'pending' || s === 'p') return 'chip-amber';
      if (s === 'cancel') return 'chip-red';
      return 'chip-neutral';
    },
    payStatusClass(status) {
      if (!status || status === '—') return 'chip-neutral';
      const s = status.toLowerCase();
      if (s === 'paid' || s === 'p') return 'chip-green';
      if (s === 'unpaid' || s === 'u') return 'chip-red';
      return 'chip-neutral';
    },
    advSearch(value) {
      this.getLoadingData = true;
      this.load = false;
      const { header, search, footer } = value;
      this.header = header;
      this.titleworksheet = search.date_from + " - " + search.date_to;
      this.search = { ...search };
      this.updateJsonFields();

      this.$store.dispatch(FETCH_COMPANY_WISE_REPORT, search)
        .then(res => {
          this.getLoadingData = false;
          this.reports = res.data.map(data => ({
            id: data.id,
            abbreviation_code: data.abbreviation_code,
            company_name: data.company_name,
            schedule_date: data.schedule_date,
            enroll_date: data.enroll_date,
            service: data.service,
            client: data.client,
            applicant: data.applicant,
            fullname: data.fullname,
            service_status: data.service_status,
            payment_status: data.payment_status,
            company_invoice_no: data.company_invoice_no,
            amount: data.amount,
            client_display_name: data.client_display_name,
            company_invoiced: data.company_invoiced,
            tcn_number: data.tcn_number
          }));
          this.excelreports = [...res.data];
          const total = res.data.reduce((s, el) => s + (el.amount || 0), 0);
          if (res.data.length) {
            this.excelreports.push({ company_name: "", schedule_date: "Grand Total", service: "", client: "", applicant: "", service_status: "", payment_status: "", amount: total });
          }
          if (footer) {
            this.excelreports.push({ company_name: "", schedule_date: footer[0], service: "", client: "", applicant: "", service_status: "", payment_status: "", amount: footer[1] });
          }
        })
        .catch(err => {
          this.getLoadingData = false;
          this.msg = err.error;
        });
    },
    updateJsonFields() {
      if (this.search.company !== "all") {
        this.json_fields = {
          "Applicant Name": "applicant",
          Service: "service",
          Location: "client",
          "Service Status": "service_status",
          "Payment Status": "payment_status",
          "Scheduled Date": "schedule_date",
          Amount: "amount"
        };
      } else {
        this.json_fields = {
          Company: "company_name",
          "Applicant Name": "applicant",
          Service: "service",
          Location: "client",
          "Service Status": "service_status",
          "Payment Status": "payment_status",
          "Scheduled Date": "schedule_date",
          Amount: "amount"
        };
      }
    },
    createInvoice() {
      this.$store.commit(SET_COMPANY_INVOICE_APPOINTMENTS, []);
      if (this.search.company === "all") {
        this.$toastr.e("Please select a company");
        return;
      }
      const ids = this.reports.filter(r => r.checked).map(r => r.id);
      if (ids.length === 0) {
        this.$toastr.e("Please select at least one appointment to generate the report");
        return;
      }
      window.localStorage.setItem("company_invoice_appointment", ids);
      this.$store.commit(SET_COMPANY_INVOICE_APPOINTMENTS, ids);
      this.$router.push({
        name: "company.report.invoicedetail",
        params: { slug: this.$route.params.client_slug, company_id: this.search.company }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$dark: #0d1b3e;
$border: #dde2ec;

.page-wrap {
  padding: 8px 0 80px;
  font-family: $font;
}

.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: visible;
}

.panel-header {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  background: #fafbfd;
  border-bottom: 1px solid #eef0f6;
  gap: 12px;
  flex-wrap: wrap;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.panel-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: $blue;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.panel-title {
  font-size: 14px;
  font-weight: 700;
  color: $dark;
  display: flex;
  align-items: center;
  gap: 8px;
}

.count-badge {
  font-size: 11px;
  font-weight: 600;
  color: #7a8499;
  background: #eef0f6;
  border-radius: 10px;
  padding: 1px 7px;
}

.panel-sub {
  font-size: 11px;
  color: #8a94a6;
  margin-top: 2px;
}

.filter-bar {
  padding: 12px 20px;
  border-bottom: 1px solid #f0f3fa;
}

.state-box {
  text-align: center;
  padding: 52px 24px;
  color: #a0aab8;
  font-size: 13px;
  font-family: $font;

  i {
    font-size: 28px;
    display: block;
    margin-bottom: 10px;
    opacity: 0.4;
  }
}

.table-wrap { overflow-x: auto; }

.cw-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  font-family: $font;
  table-layout: auto;

  thead tr {
    border-bottom: 2px solid #eef0f8;

    th {
      padding: 9px 10px;
      font-size: 11px;
      font-weight: 700;
      color: #7a8499;
      text-transform: uppercase;
      letter-spacing: 0.4px;
      white-space: nowrap;
      text-align: left;
      background: #fff;

      &.col-amt {
        text-align: right;
      }
    }
  }

  tbody tr {
    border-bottom: 1px solid #f5f7fa;
    transition: background 0.15s;

    &:last-child {
      border-bottom: none;
    }

    &:hover td {
      background: #f8fbff;
    }

    td {
      padding: 8px 10px;
      color: #2d3748;
      vertical-align: middle;
    }
  }

  tfoot tr {
    border-top: 2px solid #eef0f8;
  }
}

.col-num {
  color: #a0aab8;
  font-size: 12px;
  width: 40px;
}

.col-id {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  color: #4a5568;
}

.col-company {
  font-weight: 500;
  color: $dark;
  max-width: 160px;
  word-break: break-word;
}

.col-service {
  color: #2d3748;
  max-width: 160px;
  word-break: break-word;
}

.col-location {
  font-size: 12px;
  color: #4a5568;
  max-width: 140px;
  word-break: break-word;
}

.col-invoice {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  color: #6b7280;
}

.col-date {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}

.col-amt {
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.applicant-name {
  font-weight: 500;
  color: $dark;
  line-height: 1.3;
}

.applicant-tcn {
  font-size: 11px;
  color: #7a8499;
  margin-top: 1px;
}

/* ── Status chips ── */
.status-chip {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.chip-green {
  background: #d1fae5;
  color: #065f46;
}

.chip-amber {
  background: #fef3c7;
  color: #92400e;
}

.chip-red {
  background: #fee2e2;
  color: #991b1b;
}

.chip-neutral {
  background: #f1f5f9;
  color: #64748b;
}

/* ── Grand total ── */
.grand-total-row {
  td {
    padding: 11px 10px;
    background: #f8fbff;
  }
}

.gt-label {
  text-align: right;
  font-weight: 700;
  font-size: 13px;
  color: $dark;
}

.gt-value {
  font-weight: 700;
  font-size: 14px;
  color: $blue;
}
</style>
